module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.isEdditing) ? _c('span', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.cancel),
      expression: "cancel"
    }]
  }, [_c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('masked-input', {
    ref: "locationInput",
    staticClass: "form-control",
    staticStyle: {
      "width": "130px"
    },
    attrs: {
      "type": "text",
      "mask": "A.11.11.11.11",
      "placeholder": "_.__.__.__.__"
    },
    model: {
      value: (_vm.inputLocation),
      callback: function($$v) {
        _vm.inputLocation = $$v
      },
      expression: "inputLocation"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success btn-noborder",
    attrs: {
      "type": "submit"
    }
  }, [(_vm.loading) ? _c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }) : _c('i', {
    staticClass: "fa fa-check"
  })])])], 1)])]) : _c('span', {
    on: {
      "click": _vm.edit
    }
  }, [(_vm.location) ? _c('span', {
    staticClass: "editable text-primary"
  }, [_vm._v(_vm._s(_vm.location))]) : _c('span', {
    staticClass: "editable text-danger"
  }, [_c('i', [_vm._v("n.n.b.")])])]), _vm._v(" "), _c('text-alert', {
    attrs: {
      "alert": _vm.alert
    },
    on: {
      "update:alert": function($event) {
        _vm.alert = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8760d72c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/products/LocationEditable.vue
// module id = 740
// module chunks = 1